import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const StudentRecord = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const studentData = location.state?.studentData;

  if (!studentData) {
    return (
      <div className="w-full text-center mt-8">
        <p className="text-red-500">No student data available</p>
        <button
          onClick={() => navigate('/admin/students')}
          className="mt-4 px-4 py-2 text-blue-500 border border-blue-500 rounded hover:bg-blue-500 hover:text-white"
        >
          Back to Students List
        </button>
      </div>
    );
  }

  // Format date to display properly
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div id="main-content" className="relative pl-36 mt-16 w-full p-8 bg-[#f4f8fb]">
      <div className="w-full bg-white p-12 rounded-lg shadow-md">



        <div className="flex justify-between items-center">
          <h2 className="text-lg font-semibold mb-4">Personal Info</h2>
        </div>
        <div className="mb-6 pl-4">
          <img src={studentData?.profileURL ? studentData.profileURL : "/Assets/default_user.png"} alt="User Profile" className="size-[122px] object-cover border border-gray-300" />
        </div>

        <div className="grid grid-cols-3 gap-y-6 p-4">
          <div>
            <label className="font-semibold block">Title:</label>
            <span className="text-gray-500">{studentData.title}</span>
          </div>
          <div>
            <label className="font-semibold block">First Name:</label>
            <span className="text-gray-500">{studentData.firstName}</span>
          </div>
          <div>
            <label className="font-semibold block">Last Name:</label>
            <span className="text-gray-500">{studentData.lastName}</span>
          </div>
          <div>
            <label className="font-semibold block">Marital Status:</label>
            <span className="text-gray-500">{studentData.maritalStatus}</span>
          </div>
          <div>
            <label className="font-semibold block">Gender:</label>
            <span className="text-gray-500">{studentData.gender}</span>
          </div>
          <div>
            <label className="font-semibold block">Email:</label>
            <span className="text-gray-500">{studentData.email}</span>
          </div>
          <div>
            <label className="font-semibold block">Cell Phone:</label>
            <span className="text-gray-500">{studentData.cellPhone}</span>
          </div>
        </div>

        <div className="border-t border-gray-200 my-6"></div>

        <div>
          <h2 className="text-lg font-semibold mb-4">Biographical Information</h2>
          <div className="grid grid-cols-3 gap-y-6 p-4">
            <div>
              <label className="font-semibold block">Date Of Birth:</label>
              <span className="text-gray-500">{formatDate(studentData.dateOfBirth)}</span>
            </div>
            <div>
              <label className="font-semibold block">Country Of Birth:</label>
              <span className="text-gray-500">{studentData.countryOfBirth}</span>
            </div>
            <div>
              <label className="font-semibold block">Religion:</label>
              <span className="text-gray-500">{studentData.religion}</span>
            </div>
            <div>
              <label className="font-semibold block">Nationality:</label>
              <span className="text-gray-500">{studentData.nationality}</span>
            </div>
            <div>
              <label className="font-semibold block">Domicile City:</label>
              <span className="text-gray-500">{studentData.domicileCity}</span>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 my-6"></div>

        <div>
          <h2 className="text-lg font-semibold mb-4">Father's Information</h2>
          <div className="grid grid-cols-3 gap-y-6 p-4">
            <div>
              <label className="font-semibold block">Father Name:</label>
              <span className="text-gray-500">{studentData.fatherName}</span>
            </div>
            <div>
              <label className="font-semibold block">Father Status:</label>
              <span className="text-gray-500">{studentData.fatherStatus}</span>
            </div>
            <div>
              <label className="font-semibold block">Father's CNIC:</label>
              <span className="text-gray-500">{studentData.fatherCNIC}</span>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 my-6"></div>

        <div>
          <h2 className="text-lg font-semibold mb-4">Nationality Information</h2>
          <div className="grid grid-cols-3 gap-y-6 p-4">
            <div>
              <label className="font-semibold block">CNIC:</label>
              <span className="text-gray-500">{studentData.cnic}</span>
            </div>
            <div>
              <label className="font-semibold block">Passport Number:</label>
              <span className="text-gray-500">{studentData.passportNumber}</span>
            </div>
            <div>
              <label className="font-semibold block">Country:</label>
              <span className="text-gray-500">{studentData.addressCountry}</span>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 my-6"></div>

        <div>
          <h2 className="text-lg font-semibold mb-4">Address Information</h2>
          <div className="grid grid-cols-3 gap-y-6 p-4">
            <div>
              <label className="font-semibold block">Address:</label>
              <span className="text-gray-500">{studentData.address}</span>
            </div>
            <div>
              <label className="font-semibold block">City:</label>
              <span className="text-gray-500">{studentData.addressCity}</span>
            </div>
            <div>
              <label className="font-semibold block">District:</label>
              <span className="text-gray-500">{studentData.addressDistrict}</span>
            </div>
            <div>
              <label className="font-semibold block">Country:</label>
              <span className="text-gray-500">{studentData.addressCountry}</span>
            </div>
            <div>
              <label className="font-semibold block">Postal Code:</label>
              <span className="text-gray-500">{studentData.postalCode}</span>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 my-6"></div>

        <div>
          <h2 className="text-lg font-semibold mb-4">Application Status</h2>
          <div className="grid grid-cols-3 gap-y-6 p-4">
            <div>
              <label className="font-semibold block">Eligibility Status:</label>
              <span className="text-gray-500">{studentData.isEligible ? "Eligible" : "Not Eligible"}</span>
            </div>
            <div>
              <label className="font-semibold block">Consultation Status:</label>
              <span className="text-gray-500">{studentData.hasBookedConsultation ? "Booked" : "Not Booked"}</span>
            </div>
          </div>
        </div>


        <div className="border-t border-gray-200 my-6"></div>

        <div>
          <h2 className="text-lg font-semibold mb-4">Educational Record</h2>
          {studentData.educationDetails && studentData.educationDetails.map((education, index) => (
            <div key={education._id} className="mb-8 bg-white rounded-lg p-6">
              <h3 className="text-md font-semibold mb-4 text-blue-600">
                {education.qualificationLevel}
              </h3>
              <div className="grid grid-cols-3 gap-6 p-4">
                <div>
                  <label className="font-semibold block">Institute Name:</label>
                  <span className="text-gray-500">{education.instituteName}</span>
                </div>
                <div>
                  <label className="font-semibold block">Program:</label>
                  <span className="text-gray-500">{education.programTitle}</span>
                </div>
                <div>
                  <label className="font-semibold block">Major:</label>
                  <span className="text-gray-500">{education.major}</span>
                </div>
                <div>
                  <label className="font-semibold block">Department:</label>
                  <span className="text-gray-500">{education.department}</span>
                </div>
                <div>
                  <label className="font-semibold block">Campus:</label>
                  <span className="text-gray-500">{education.campus}</span>
                </div>
                <div>
                  <label className="font-semibold block">Registration Number:</label>
                  <span className="text-gray-500">{education.registrationNumber}</span>
                </div>
                <div>
                  <label className="font-semibold block">Duration:</label>
                  <span className="text-gray-500">
                    {formatDate(education.startDate)} - {education.incompleteEducation ? 'Present' : formatDate(education.endDate)}
                  </span>
                </div>
                <div>
                  <label className="font-semibold block">Location:</label>
                  <span className="text-gray-500">{`${education.instituteCity}, ${education.instituteCountry}`}</span>
                </div>
                <div>
                  <label className="font-semibold block">Score:</label>
                  <span className="text-gray-500">
                    {education.obtained}/{education.total} ({education.gradingSystem})
                  </span>
                </div>
                <div>
                  <label className="font-semibold block">Education System:</label>
                  <span className="text-gray-500">{education.educationSystem}</span>
                </div>
                <div>
                  <label className="font-semibold block">Status:</label>
                  <span className={`text-${education.incompleteEducation ? 'green' : 'red'}-500`}>
                    {education.incompleteEducation ? 'Completed' : 'Not Completed'}
                  </span>
                </div>
              </div>
              {index < studentData.educationDetails.length - 1 && (
                <div className="border-t border-gray-200 mt-6"></div>
              )}
            </div>
          ))}
          {(!studentData.educationDetails || studentData.educationDetails.length === 0) && (
            <div className="text-center text-gray-500 py-4">
              No educational records available
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default StudentRecord;